@for (item of items; track item) {
  <span>
    <span class="badge badge-primary cursor-pointer me-1"
      (click)="removeSelectedItem(item)"
      data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Remove">
      {{item.firstName ? item.firstName.substring(0, 1) + '. ' + item.lastName : item.name}} <i class="fa fa-times-circle"></i>
    </span>
  </span>
}
<input type="text" class="form-control" [ngClass]="{ 'opacity-50': isLoading }"
  [placeholder]="placeholder" onClick="this.select()" autocomplete="off" #searchInput>
<span class="fa input-icon" [ngClass]="{'fa-search': !isLoading, 'fa-circle-o-notch fa-spin': isLoading }"></span>
<div class="dropdown">
  @if (!hideMenu) {
    <div class="dropdown-menu" [ngClass]="{'d-block': itemsFound.length }">
      @for (item of itemsFound; track item) {
        <a class="dropdown-item" (click)="selectItem(item)">
          {{item.firstName ? item.firstName + ' ' + item.lastName : item.name}} {{item.organ ? '(' + item.organ + ')' : ''}}
        </a>
      }
    </div>
  }
</div>